/*
TODO
//0.Add any two stick meters, (ex: whatmeter) and it will break!!
//1. set selection off when selecting a thumb, currently rectangle selection is still there while selecting other thumb
//2. refresh thumb when press delete at keyboard, should be triggered from the lab it self down to the Thumb
//3. $ jquery is needed also iside the lab!
//4. Social layer ( views number, creator link and profile, share button)
//4.2 Destingush between show for the same signed in user and for a nother user
4.3 Change language menu
//4.3.3 Lanuage mapping!
//4.4 Logo, press on opens the home page ( also should maintain locale)
//4.5 share button functionality as here: https://github.com/nygardk/react-share
//4.5.1 set networks IDs for buttons! very important, it was facebook messager, I removed it
//4.5.3 hide share number if zero, if possible
//4.5.2 embed iframe share
//4.6 user name hyper link
//4.7 turn profile drop list into hyper links
//4.5 Try single and double quotation in description, it causes errors
//5. Hide for social page Save, Load, Save button, Save as
//6. Licesne layer
//view restriction
//allowed components
//trail
//subscription
//6.5 Update license on tab focus
//7. SEO, Google Analytics, meta tags
//7.5. Text check box keeps set unselected by it self!
//8. Classroom selection, playground.
//8.5 When sign in in another tab, the catch up is not working for classroom drop list, and the z-index failed
//9. Rich text, NGSpice log
//10. NGSpice integrtion.
10.5 show ngspice logs directly when ngspice got enabled when use it working and notes are empty
10.7 don't set notes on when viewing in mobile
999 this experiment crashes when opening! https://staging.dcaclab.com/en/experiments/9915-test-diode-readings

//12. favicon
// 13. analysis loop popups
// 14. oscoliscope canada old about popus, (types and grounds)
15. check timeout for save, should be long enough, try saving 5 slides, big descriptions
15.5 when error saving, show retry after X seconds, cancel at retry is not good idea, still we don't want to block user
retry should be automatically after X seconds
//16. Remove does not actually remove the slide!
//17. Saving does not update the thumbnail
//17.5 Check that his url is expired at cloudfront:
//6-March-2020 this file was deleted, but serverd from cloudfront
//https://s3cdn.dcaclab.com/experiments/thumbnails/000/019/000/original/uploaded-1615031103268.jpg?1615031123
//as I have read, it should stay for 24 hours before it get read from s3 again
//if it still be there after 24 hours, this should be fixed, I've checked, its removed.

//18. Saving should popup the input form, not to keep the input always visible
//19. When backspace in circuit name input, it will delete what selected at board!
//20. Prompt user before going away from lab page
//21. Saving more than 50 circuits? tell user why it has failed saving
//22. Copy components and paste is not working!
//23. Text covers show all!
//24 tinymce remove not free plugins, remove not needed plugins
//25. Set background of slide to the same as in the lab! ;)
//26. Zoom at menu to avoid getting covered by text
//28. Zooming bars in lab needs invalidate to show
//29. Prevent click on a slide while opening
//30. select a slide, why opening all components in seqence?
31. window.view_only_mode consicuences
//32. stackable for main menu, test with mobile, user menu test with mobile
33. haxe scrollers handlers not working at edges
34. share like circuitlab
35. Make sure iframe still work after deployment
careful, debug mode for ngspice logs will make browser issesponsive specially for long logs
http://localhost:3000/en/experiments/19005-3-xx
Uncaught TypeError: Window.channel is undefined

after test
//notification style is broken on staging!
//experiment title is not at the page head or title(hover over tab to see its not..)
//avoid opening empty notes when open a circuit
//enlarge user card width at show mode, check here: https://staging.dcaclab.com/en/experiments/18163-margarita-maria-cecilia-pinzon-serrano-901-1
this circuit breaks only when using react https://staging.dcaclab.com/en/experiments/17335-practica-6-1 it has worked on production without react
NGSpice when load circuit and is not connected yet, checking it will not load the simulation, unless it was checked before..
example: https://staging.dcaclab.com/en/experiments/18345-alvaro-perez-y-daniel-viveros-ejs-12-y-3
check for connecting, then you have to uncheck and check again for simulation, while this should be one check only for connecting and simulation.
//animate.css is not loaded!

open top ten circuits at staging, one of them will break
adding oscoliscope bin on stage breaks on staging!

https://react-rte.org/demo

//*. Create two sliders, delete the first one, the second one is actually deleted!
*. iframe does not work!
*. two versions to have: with webgl and without, have the webgl fixed, let there a setting for it and automated deploy.
*. transformer is fixed for non ngspice? but its not as the same as ngspice, seems ngspice should be inverted
//*. property inspector, units are not shown for droplist, fixed
*. properties inspector locked, user needs to sign in, he signed in, he is subscriber or within trial, inspector still blocked! he needs to refresh the page to make it work
*. thumbnail capture is not working! it seems not working for new experiments?

*/
import React, { Component } from 'react';
import {
    Grid,
    Button,
    Confirm,
    Icon,
    Popup,
    Modal,
    Input,
    Label,
    Loader,
    Dimmer,
    Advertisement
} from 'semantic-ui-react';
import Slide from './Slide'
import * as Tone from "tone";
import {BasicAd} from "./BasicAd";
// import Tagger from "./Tagger";
const synth = new Tone.Synth().toDestination();

let sounds = new Map();
const vol = new Tone.Volume(-45).toDestination();
class Thumbs extends Component {

    refreshing_thumb = false;
    syncing = false;
    slides_to_open = 0;
    constructor(props){
        super(props);

        window.thumbs = this;
        this.state = { saving_tags: false, setting_tags: false, setCurrentSlide: props.setCurrentSlide, is_confirming: -1, opening: false, finished_opening: false, current_slide: -1, slides: []};
    }

    correctAndRoundNumber = (num) => {
      if (num === 0) {
        return "0.00";
      }
    
      const prefixes = [
        { threshold: 1e9,  symbol: 'G' },
        { threshold: 1e6,  symbol: 'M' },
        { threshold: 1e3,  symbol: 'k' },
        { threshold: 1,    symbol: ''  },
        { threshold: 1e-3, symbol: 'm' },
        { threshold: 1e-6, symbol: 'µ' },
        { threshold: 1e-9, symbol: 'n' },
      ];
    
      for (let i = 0; i < prefixes.length; i++) {
        if (Math.abs(num) >= prefixes[i].threshold) {
          let scaledNum = num / prefixes[i].threshold;
          // Adjust the precision based on the scaled number
          let precision = scaledNum < 10 ? 3 : scaledNum < 100 ? 2 : 0;
          return scaledNum.toFixed(precision) + prefixes[i].symbol;
        }
      }
    
      // At this point, all numbers smaller than 1e-9 (inclusive) should be represented in 'pico' units
      let scaledNum = num / 1e-12;
      // Adjust the precision for very small numbers
      let precision = Math.abs(scaledNum) < 10 ? 3 : 2;
      return scaledNum.toFixed(precision) + 'p';
    };
    


    getDataLabel = (str, role, full = false, metric_type = 'I') =>{
      if (str == null)return str;
      
      if (role == 'amp' || role == 'component' || role == 'metric'){        
        if (role == 'metric'){
          //if (str.startsWith("vV")) str = str.substring(1);      
          if (str.startsWith("rR")) 
          str = "I("+str.substring(1)+")";      
          else
          if (str.startsWith("N")) str = "V("+str+")";      
          else
          if (str.startsWith("Vr")) str = "I("+str.substring(2)+")";      
          else
          str = "I("+str+")";      
          return str;
        }

        if (str.startsWith("Vr")) str = str.substring(2);      
        if (str.startsWith("Vl")) str = str.substring(2);      
        if (str.startsWith("Vc")) str = str.substring(2);      
        if (full)
        return 'i(' + str + ')';
        else
        return str;
      }
      else
      if (full)
      return 'v(' + str + ')';    
      else
      return str;
    }

    alert = (str, passed_type = 'lock') => {
      
      
      switch (str) {
        case 'Time Domain is not available in the starter version':
          str = l.time_domain_limitation;
          break;
        case 'DC Sweep is not available in starter version':
          str = l.dc_sweep_limitation;
          break;
        case 'Private circuit is not available in starter version':
          str = l.private_circuit_limitation;
          break;
        case 'Integrated circuit modeling is not available in starter version':
          str = l.ic_creator_limitation;
          break;
        case 'This component is not available in starter version':
          str = l.this_component_limitation;
          break;
        case 'Add circuit slide is not available in starter version':
          str = l.slides_limitation;
          break;
      }
      // If there's a toast notification system available through props, use it
      if (this.props.showToast) {
        this.props.showToast({
          type: passed_type,
          title: 'Alert',
          description: str,
          time: 5000 // Display for 5 seconds
        });
      }
    }
    setCurrentMouseEvent = (event) => {
      this.props.setCurrentMouseEvent(event);
    }
    apply_error = (error) => {
      // error came from calling lambda 
      this.props.setSelectedAmperesValues({labels:[], datasets: []}); 
      this.props.setSelectedVoltsValues({labels:[], datasets: []}); 
      this.props.setVSweepValues({labels:[], datasets: []}); 
      this.props.setChartLoading(false);
      if (error != null){
        // I found its called from haxe too with error null
        // this is when no print exist in the netlist
        // which is actually not a real error 
        this.props.setSimulationError(error);
      }
    }
    setZoomValue = (val) => {      
      this.props.setZoomValue(val);
    }
    setChartsLocation = (loc) => {
      if (loc.y > 450 ) 
      loc = {x: loc.x, y: 450};

      this.props.setInitialLocation(loc); 
    }
    setCharts = (picked_dc_sweep_source, 
      v_sweep ,
      metric_nodes, 
      dc_sweep_sources, 
      analysis_mode, 
      initialLocation, 
      initial_checks_selected, 
      currents_names, 
      v_times, 
      v_vectors, 
      t_times, 
      t_vectors, 
      available_nodes) => {
      // console.log(available_nodes, "initial_checks_selected", initial_checks_selected);
      if (available_nodes == null) available_nodes = [];
      available_nodes= available_nodes.filter(node => node.point.x < 10000);      
      
      const parsedVData = v_vectors == null ? {} : JSON.parse(v_vectors);      
      const parsedCData = t_vectors == null ? {} : JSON.parse(t_vectors);      
      const parsedVSweepData = {...parsedVData, ...parsedCData};
      
      const chart_volts_data = {
          labels: v_times,
          datasets: Object.keys(parsedVData).map(key => {
            return {
                label: this.getDataLabel(key, 'volt'),
                data: parsedVData[key],
                borderWidth: 2,
                borderColor: this.findColorByLabel(key, [ ...available_nodes, ...currents_names ]),
                backgroundColor: this.findColorByLabel(key, [ ...available_nodes, ...currents_names ]),
            };
        })
      }      

      const chart_amperes_data = {
        labels: t_times,
        datasets: Object.keys(parsedCData).map(key => {
          return {
              label: this.getDataLabel(key, 'component'),
              data: parsedCData[key],
              borderWidth: 2,
              borderColor: this.findColorByLabel(key, currents_names),
              backgroundColor: this.findColorByLabel(key, currents_names),
          };
      })
      }      
      
      const chart_v_sweep_data = {
        labels: v_sweep.map(v => this.correctAndRoundNumber(v) + "V"),
        datasets: Object.keys(parsedVSweepData).map(key => {
          var metric_type = this.findObjectByLabel(key, metric_nodes);
          metric_type = metric_type ? metric_type.metric_type : 'I';
          return {
              label: this.getDataLabel(key, 'metric', metric_type),
              data: parsedVSweepData[key],
              borderWidth: 2,
              pointRadius: 1,
              borderColor: this.findColorByLabel(key, metric_nodes),
              backgroundColor: this.findColorByLabel(key, metric_nodes),
          };
        })
      }
      
      this.props.setPickedDCSweepSource(picked_dc_sweep_source);
      this.props.setMetricNodes(metric_nodes);
      this.props.setDCSweepSources(dc_sweep_sources);
      this.props.setAnalysisMode(analysis_mode); 
      this.props.setInitialLocation(initialLocation); 
      this.props.setSelectedVoltsValues(chart_volts_data); 
      this.props.setSelectedAmperesValues(chart_amperes_data); 
      this.props.setVSweepValues(chart_v_sweep_data); 
      if (initial_checks_selected == null)initial_checks_selected =[];      
      this.props.setInitialChecksSelected(initial_checks_selected); 
      this.props.set_currentable_names(currents_names); 
      // VOLT NODES:
      this.props.setNodes(available_nodes);
      this.setChartLoading(false);
      // Further processing or state updates 
    }
    parsedDataToRole = (key, currents, volts) => {
      if (currents[key] != null)return 'component';
      if (volts[key] != null)return 'volt';
      return 'metric';
    }
    findObjectByLabel = (label, arrayOfObjects) => {
      const foundItem = arrayOfObjects.find(item => item.label === label);
      return foundItem;
    }
    findColorByLabel = (label, arrayOfObjects) => {      
      const foundItem = arrayOfObjects.find(item => item.label === label);
      return foundItem ? foundItem.css_color : null;
    }
    setChartLoading = (bool) => {
      this.props.setChartLoading(bool);
    }
    // called from simulator
    setNodes = (nodes, components) => {      
      this.props.setNodes(nodes);
      this.props.set_currentable_names(components);
    }
    playNote = (note) => {
        synth.triggerAttackRelease(`${note}4`, "16n");
    }
    switchAudio = (id, off, form = 'sine') => {
        Tone.start();
        id = "switch"
        if (sounds.has(id) == false){
            sounds.set(id, new Tone.Synth({
                oscillator: {
                    type: form,
                    modulationFrequency: 0.2
                },
                envelope: {
                    attack: 0,
                    decay: 0.1,
                    sustain: 0,
                    release: 0.1,
                }
            }).connect(vol));
            // Initialize last trigger time
            sounds.set(id + '_lastTrigger', 0);
        }
        let osc = sounds.get(id);
        let lastTriggerKey = id + '_lastTrigger';
        let currentTime = Tone.now();
        let lastTriggerTime = sounds.get(lastTriggerKey) || 0;

        // Ensure minimum 150ms between triggers to prevent timing conflicts
        if (currentTime - lastTriggerTime >= 0.15) {
            try {
                osc.triggerAttackRelease(440, '8n', currentTime);
                sounds.set(lastTriggerKey, currentTime);
            } catch (e) {
                console.log("Switch audio error:", e);
            }
        }
    }
    connected = (doer)=>{
        Tone.start();
        this.switchAudio(doer, true, "triangle");
    }
    deleteAudio = (id)=>{
        if (sounds.has(id) == true){
            let osc = sounds.get(id);
            osc.stop();
            sounds.delete(id);
        }
    }
    muteAudio(id) {
      let key = `${id}_vol`;
      if (sounds!= null && sounds.has(key)){        
        let volume = sounds.get(key);
        volume.volume.value = -Infinity;
      }
    }

    buzzerAudio = (id, voltage, frequency, Vfactor)=>{
      Tone.start();
      if (sounds.has(id) == false){
          sounds.set(`${id}_vol`, new Tone.Volume().toDestination())
          sounds.set(id, new Tone.Oscillator(frequency, "sine").connect(   sounds.get(`${id}_vol`)     ));
          
      }
      let osc = sounds.get(id);
      let volume = sounds.get(`${id}_vol`);
      
      voltage = Math.abs(voltage);
      
      try {
          if (osc.state != "started") {
              osc.start();
          }
      } catch (e) {
          console.log(e);
      }
  
      if (voltage < 3)  // Assuming 3V as a minimum threshold for sound
          osc.stop();
  
          let volumeValue = voltage * 5 - 50; // Mapping voltage to decibels (dB) in a simple way; adjust as needed.
          if (volumeValue > 0) volumeValue = 0;  // Making sure not to exceed 0 dB
          if (volumeValue < -50) volumeValue = -50;  // Limiting minimum volume
      
          // Applying the factor to adjust the volume level
          // volumeValue = volumeValue * factor - (50 * (1 - factor));

          volume.volume.value = Vfactor;//volumeValue;  // Set the volume level in dB
      
          osc.set({
              frequency: frequency,  // Keeping a constant frequency for the buzzer sound
          });      
  }
  
    fanAudio = (id, freq)=>{
        Tone.start();
        if (sounds.has(id) == false){
            sounds.set(id, new Tone.Oscillator(440, "sawtooth10").connect(vol));
        }
        let osc = sounds.get(id);
        freq = Math.abs(freq);
        try {
            if (osc.state != "started") {
                osc.start();
            }
        } catch (e) {
            console.log(e);
        }


        if (freq < 2)
            osc.stop();

        osc.set({
            frequency: freq* 8,
            amplitude: -100
        });
    }
    setConfirm = (i) => {
      this.setState({ is_confirming: i })
    }

    lab(command, arg = null, arg2 = null){
        try {
            return com.clientside.main.Html5Bootstrap.jsCall(command, arg, arg2);
        } catch (e) {
            console.log(e);
        }
        return "";
    }
    lab_state(){
        let bg_color = this.lab("getBGColor") ? this.lab("getBGColor").toString(16) : 'cccc66';
        let base64_shapshot = this.lab("captureLab")
        let data = this.lab("getCircuit")
        let text = this.props.getDescription()
        let question = this.props.getQuestion()
      return {bg_color, base64_shapshot, data, text, question, annotation_texts: this.lab("getAnnotationTexts")}
    }


    //called when user alter anything on circuit at haxe side
    sync(text_only= false){
        if (this.state.slides[0]!=null)

        if (!this.syncing) {
            this.syncing = true;
            let slides = [...this.state.slides];
            let labstate = text_only ? {...slides[this.state.current_slide], text: this.props.getDescription(), question: this.props.getQuestion()} : this.lab_state();
            slides[this.state.current_slide] = labstate;
            this.setState({slides});
            this.syncing = false;
        }
    }
    lab_is_loaded(circuits, descriptions, questions = [], tags = []){

      // Log environment information when lab is loaded
      com.clientside.main.Html5Bootstrap.jsCall("set_official_ics", this.props.official_ics);
      com.clientside.main.Html5Bootstrap.jsCall("set_user_ics", this.props.user_ics);
      com.clientside.main.Html5Bootstrap.jsCall("clear_ics");

            
      let slides = circuits.map((circuit, index) => (
        {...this.lab_state(), data: circuit, text: descriptions[index] == null ? "" : descriptions[index], question: questions[index]  == null ? "" : questions[index]}
      ))
      let current_slide = window.action_name == 'lab' ? 0 : -1;
      let restore = false; //I am not sure when to restore the work, maybe ask him first?

      if (restore && localStorage.getItem('offlineCircuit')!= undefined){
        let offline_slide = JSON.parse(localStorage.getItem('offlineCircuit'));
        slides=[offline_slide];
        current_slide = -1
      }

      this.slides_to_open = slides.length;
      this.setState(
        {opening: true, current_slide, slides, tags}
      );

      this.props.setLabLoaded(true);
      this.props.onLabLoaded();
      //start_limited when user is not signed in only
      if (this.props.user === false) window.labLayout("start_limited");
      this.lab("insideReact", this.props.is_mobile);
    }
    componentDidUpdate(prevProps, prevState){


      if (this.state.opening && this.state.current_slide >= 0 && !this.refreshing_thumb)
      {
        const slide = this.state.slides[this.state.current_slide];
        const base64_shapshot = (slide == null) ? "" : slide.base64_shapshot;

        let num = this.state.current_slide-(base64_shapshot == "" ? 0 : 1);

        if (num< 0)num= 0;
        this.setState(
          {opening: num > 0,
            current_slide: this.state.current_slide > 0 ? this.state.current_slide - 1 : 0 , slides: this.state.slides}
        );
      }
      else
      if (this.state.opening && prevState.current_slide == -1)
      {
        //trigger slides capturing
        this.select(this.state.slides.length-1);
      }
    }

    set_circuit(circuit, byClick = false){

      //clear all haxe timers
      var highestTimeoutId = setTimeout(";");
      for (var t = 0 ; t < highestTimeoutId ; t++) {
          //do not remove haxe playframe timer, as would it prevent simulation run at create new assignment
          if (t != window.play_frame_timer && t != window.dots_timer_handle) clearTimeout(t);
      }

      if (this.slides_to_open >= 0){ // >= will make animate true only when first opened the experiment
        this.slides_to_open--;
        // if (circuit['text'] && circuit['text'].length)
        // console.log("L:" + circuit['text']);
        const empty_string = '<p><br data-mce-bogus="1"></p>';
        
        
        if (this.slides_to_open == 0) {
          if (circuit) {
              if (circuit['text'] || circuit['question']) {
                  
                      
                          this.props.setVisible(true);
                      
                  
              }
          }
      }

      

      }

      const animate = this.slides_to_open == 0 || byClick;
      com.clientside.main.Html5Bootstrap.jsCall("setCircuit", circuit.data, animate);

      this.props.setDescription(circuit.text)
      this.props.setQuestion(circuit.question)
      if (!animate && this.state.current_slide >=0)
      {
        this.refreshing_thumb = true;
      }
    }
    refresh_current_thumb =()=>{

      var slides = [...this.state.slides];
      slides[this.state.current_slide] = this.lab_state();
      this.refreshing_thumb = false;
      this.setState(
        {current_slide: this.state.current_slide, slides}
      );

      if (localStorage.getItem('triedToSave') != undefined && this.props.user){
        localStorage.setItem('triedToSave', undefined)
      }
    }
    select = (i) =>{

        // this.playNote("C");

      this.setState(
        {...this.state, current_slide: i}
      );
        this.state.setCurrentSlide(i)

    }
    delete = (index) =>{

      let current_slide = this.state.current_slide;
      if (index <= current_slide){
        current_slide--;
        if (current_slide < 0)current_slide = 0;
      }
      var slides = [...this.state.slides];
      slides.splice(index, 1);

      this.setState({
        current_slide, slides: slides
      });
      // this.select(current_slide+1)

      setTimeout(()=>{
        this.set_circuit(this.state.slides[current_slide], !window.thumbs.state.opening);

      }, 1)




    }
    set_tags = () =>{
        this.setState({setting_tags : true})
    }

    add_slide = (duplicate = false) =>{
      this.refresh_current_thumb();
      if (!duplicate){
        this.lab("newCircuit")
      }
      this.setState(
        {current_slide: this.state.slides.length, slides: [...this.state.slides,
          {bg_color: '#'+this.lab("getBGColor").toString(16), base64_shapshot: this.lab("captureLab"), data: this.lab("getCircuit"), text: ""}
        ]}
      );
      if (!duplicate){
        setTimeout(()=>{
          this.props.setDescription("")
        }, 1)
      }

    }
    moveSlide = (n, dir) => {
        let caller = this.state.slides[n]
        let replaced = this.state.slides[n + dir]
        let slides = [...this.state.slides]
        slides[n] = replaced
        slides[n+ dir] = caller
        this.setState({slides: slides})
        setTimeout(()=>{
            this.select(n + dir);
        }, 1)
    }
    duplicate_slide = () => {
      const circuit = this.lab_state();
      this.add_slide(true);
      this.setState(
        {current_slide: this.state.current_slide, slides: [...this.state.slides, circuit]}
      );

    }
    remove_slide(){
    }

  render() {
    return (
      <div style={{backgroundColor: "transparent"}}>
        <p style={{textAlign: 'center', color: this.props.forecolor}}>{l.slides}</p>
        {this.state.slides.map((slide_info, index) => (
        <Slide moveSlide={this.moveSlide} index={index} setConfirm={this.setConfirm} key={index} single={this.state.slides.length == 1}
        select={(i)=>this.select(i)}
        last={index === this.state.slides.length -1}
        number={index+1} selected={index == this.state.current_slide}
        opening={this.state.opening}
        circuit={slide_info}
        set_circuit={(circuit, byUser)=>this.set_circuit(circuit, byUser)}
        />
        ))}

        {this.state.slides.length > 0 &&
        <Grid style={{marginLeft: 2, paddingTop: 20}}>

            <Popup content='Add circuit slide' trigger={
                <Button disabled={this.state.slides.length >= 3} icon='add' onClick={() => {                                      
                      window.thumbs.sync();
                      setTimeout(() => {
                          this.add_slide()
                      }, 1)                    
                }} size='mini'/>
                }
            />
            <Popup content='Duplicate current circuit' trigger={
            <Button disabled={this.state.slides.length >= 3} icon='copy' onClick={()=>{
                this.duplicate_slide()
            }} size='mini' />
            }
            />



            {false && this.props.user &&
            <Popup content='Set tags' trigger={
                <Button
                    onClick={() => {
                        this.set_tags()
                    }}
                    style={{marginLeft: 2, marginTop: 50}} color='google plus'>
                    <Icon name='tag'/> Tags
                </Button>
            }
            />
            }


        </Grid>


        }

          <Modal
              dimmer={false}
              open={this.state.setting_tags}
          >
          <Modal.Header>Tags</Modal.Header>
          <Modal.Content>Put a comma between each one. Example: bulbs, switches
                <br />
              <Dimmer active={this.state.saving_tags}>
                  <Loader>Saving...</Loader>
              </Dimmer>
              {/*<Tagger tags = {this.state.tags} setTags={(tags)=>{this.setState({tags})}} parent={this}/>*/}
              <br />
              </Modal.Content>


              <Modal.Actions>
                  <Button positive
                  style={{width: 70}}
                          onClick={()=>{this.setState({setting_tags: false})}}
                  >
                      Close
                  </Button>
              </Modal.Actions>

          </Modal>


      <Confirm
        open={this.state.is_confirming >= 0}
        onCancel={()=>this.setConfirm(-1)}
        onConfirm={(e)=>{
          e.stopPropagation();
          this.delete(this.state.is_confirming);
          this.setConfirm(-1);
        }
        }
        size='mini'
        />
    </div>
    );
  }
}

export default Thumbs;
